<template>
  <div class="viewport viewport-with-top-nav viewport-compact align-items-center justify-content-center">
    <spinner v-if="loading"></spinner>
    <template v-else>
      <top-nav></top-nav>
      <div class="alert alert-warning mb-5" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="alert-heading">
          <strong v-html="$t(`LoginOtpReturningCustomer.${type}.title`)"/>
        </div>
        <div class="small" v-html="$t(`LoginOtpReturningCustomer.${type}.message`)"/>
      </div>
      <otp @otp-success="onOtpSuccess" :pin="pin" v-if="pin"></otp>
      <div class="small text-muted-more mt-3 px-5">
        {{ $t('LoginOtpPage.phoneNumberNotValidPleaseVisit') }}
        <router-link :to="{name: 'branches'}">{{ $t('LoginOtpPage.anyOfOurBranches') }}</router-link>
      </div>
    </template>
  </div>
</template>

<script>
import store from '@shared/store'
import Otp from '@shared/components/Otp'
import TopNav from '@shared/components/TopNav'
import UserMixin from '@shared/mixins/UserMixin'

export default {
  components: { Otp, TopNav },
  mixins: [UserMixin],

  data() {
    const application = store.getApplication()
    return {
      loading: true,
      pin: application && application.borrower && application.borrower.pin
    }
  },
  async mounted() {
    if (!this.pin) {
      await this.$router.replace({ name: 'home' })
    } else {
      this.signIn()
    }
  },
  methods: {
    signIn() {
      this.signInRequest(this.pin)
          .then(() => {
            this.loading = false
          })
          .catch((e) => {
            console.log(`[login otp page] sign in failed: ${e}`)
            this.$router.back()
          })
    },
    onOtpSuccess() {
      this.getAndStoreCustomerProfile(this.pin).then(() => this.redirectToCustomerOverview(this.pin))
    }
  },
  computed: {
    type() {
      if (this.$configuration.newCoreEnabled) {
        return 'ncReturningCustomer'
      }
      return this.$route.query.withUsedOffer ? 'withUsedOffer' : 'hasOffer'
    }
  }
}
</script>
